type OwnerType = "agency" | "client" | "prospect";

export function shouldOfferPayCycleApply(params: {
  ownerType: OwnerType;
  ownerId?: string;
  oldValue: string;
  newValue: string;
}): boolean {
  return (
    params.ownerType === "client" &&
    !!params.ownerId &&
    params.newValue.length > 0 &&
    params.newValue !== params.oldValue
  );
}

export function filterActiveEmployees<T extends { status?: string | null }>(employees: T[]): T[] {
  return employees.filter((e) => (e.status ?? "").toLowerCase() === "active");
}

export function resolveApplyTargetIds(params: {
  mode: "all" | "choose" | "new";
  activeEmployeeIds: number[];
  selectedIds: Set<number>;
}): number[] {
  if (params.mode === "all") return params.activeEmployeeIds;
  if (params.mode === "choose") return Array.from(params.selectedIds);
  return [];
}
